module.exports = __webpack_public_path__ + "static/media/testimonial-2.dc798613.jpg";